import { render, staticRenderFns } from "./CostManagement.vue?vue&type=template&id=0cba7c5c&scoped=true"
import script from "./CostManagement.vue?vue&type=script&lang=js"
export * from "./CostManagement.vue?vue&type=script&lang=js"
import style0 from "./CostManagement.vue?vue&type=style&index=0&id=0cba7c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cba7c5c",
  null
  
)

export default component.exports